import { toast } from './core/use-toast';

export { Toaster } from './components/toaster';
export { toast };
export default toast;
